export const menuScroll = (id) => {
    let coord = document.querySelector(id).offsetTop - 100;
    window.scroll({
        top: coord,
        behavior: 'smooth'
    })
}